  import React, { Component } from "react";
  import { Form, Input, Label } from 'semantic-ui-react'
  // import { validJSONDate } from '../libs/sharedFunctions'


  export default class DatePickerHTML extends Component {
  constructor(props)
  {
    super(props);
    this.onTextChange= this.onTextChange.bind(this);
    this.state = {textValue: this.props.value, isError: false, errorText: ""};

  }

onTextChange(event, data)
{
  var newValue=event.target.value;
  const field=this.props.field;
  var isError=false 
  var errorText=""
  console.log(event, data)
  if(newValue==="") newValue=null
  // console.log(newValue)

  //validation
  if(!field.nullable && newValue===null)
  {
    isError=true;
    errorText="Required"      
  }

  if (newValue)
  {
    this.props.onChange(this.props.fieldname, this.props.field, newValue, !isError)
    this.setState({textValue: newValue, isError: isError, errorText: errorText})
  }
  
  
}

    render() {

      const showlabel=this.props.showlabel;
      const inline=this.props.inline;
      const showError=this.state.isError;
      return (
          <Form.Field required={!this.props.field.nullable}>
          {showlabel && <label style={{color: this.props.darkmode ? "white": "black"}}>{this.props.field.label}</label>}
          {inline ? (<Form.Input type='date' inline placeholder={this.props.field.label} value={this.state.textValue} onChange={this.onTextChange} disabled={!this.props.enabled}/>)
          : (<Form.Input type='date' placeholder={this.props.field.label} value={this.state.textValue} onChange={this.onTextChange} disabled={!this.props.enabled} />)}
          {showError && <Label pointing>{this.state.errorText}</Label>}
          </Form.Field>
      );
    }
  }